<template>
    <div>
        <div class="dropdown-menu crm-header-panel dropdown-tasks-holder" v-el:dropdown v-if="visible" transition="crm-header-fade" :style="getStyle()">
            <div class="notification-header"><span>Tarefas</span><i class="fa fa-tasks" aria-hidden="true"></i></div>
            <div v-if="loading" class="crm-panel-empty">
                Carregando...
            </div>
            <div v-if="!loading && !hasTasks" class="crm-panel-empty">
                Não há tarefas.
            </div>
            <div v-slimscroll :height="400" :always="false" v-if="!loading && hasTasks">
                <ul class="dropdown-tasks">
                    <li v-for="task in tasks">
                        <x-task :task.sync="task" :task-status-changed="taskStatuschanged" :close-dropdown="closeDropdown" :done="taskButtonClicked"></x-task>
                    </li>
                </ul>
            </div>
        </div>
        <property-info-handler v-ref:property-info></property-info-handler>
        <button class="btn default quick-view-customer btn-xs"
                v-quick-view-customer
                v-bind:data-id="ui.currentCustomerId"
                v-bind:data-root="'/customers/'"
                title="Visualizar"
                style="position: relative;z-index:2;border-bottom-right-radius:3px;border-top-right-radius:3px;display: none"
                v-el:view-customer-button>
            <i class="fa fa-eye"></i>
        </button>
    </div>
</template>

<script>
    const R = require('ramda')
    const utils = require('sci/utils')
    const moment = require('moment')
    const taskCreatedSub = require('sci/subscriptions/task-created')
    const taskStatusChangedSub = require('sci/subscriptions/task-status-changed')
    const client = require('sci/helpers/queue-client')
    const XTask = require("./Task.vue")

    const { list } = require('./helpers')

    export default {
        name: 'NavbarDropdownPopup',
        components: {
            XTask
        },
        props: {
            visibilityChanged: {
                type: Function
            },
            hasNewChanged: {
                type: Function
            },
            hasNewDone: {
                type: Function
            },
            hasNewRunning: {
                type: Function
            }
        },
        init () {
            this.$newEl = null;
            this.$taskCreatedEventSubscription = null;
            this.$taskStatusChangedEventSubscription = null;
        },
        data: () => ({
            loading: false,
            tasks: [],
            visible: false,
            top: 0,
            right: 0,
            ui: {
                currentCustomerId: null
            },
            lastOpen: null,
            overrideDone: []
        }),
        destroyed () {
            this.destroyEvent()
            document.body.removeChild(this.$newEl)

            if (this.$taskCreatedEventSubscription) {
                this.$taskCreatedEventSubscription.unsubscribe()
            }

            if (this.$taskStatusChangedEventSubscription) {
                this.$taskStatusChangedEventSubscription.unsubscribe()
            }
        },
        ready () {
            this.lastOpen = localStorage.getItem("queue:last-open") || null

            if (!this.lastOpen) {
                this.lastOpen = moment().utc().format("YYYY-MM-DD HH:mm:ss")
                localStorage.setItem("queue:last-open", this.lastOpen)
            }

            this.$newEl = this.$appendTo(document.body).$el

            this.load()

            this.$taskCreatedEventSubscription = taskCreatedSub.subscribe(this.taskCreatedEvent)
            this.$taskStatusChangedEventSubscription = taskStatusChangedSub.subscribe(this.taskStatusChangedEvent)
        },
        methods: {
            taskButtonClicked () {

            },
            closeDropdown() {
                this.visible = false
            },
            taskCreatedEvent(a, b, c) {
                this.load()
            },
            taskStatusChangedEvent(a, b, c) {
                if (a && (a.status === 'DONE' || a.status === 'FAILED' || a.status === 'CANCELLED' || a.status === 'ABORTED')) {
                    this.overrideDone.push(a.id)
                    this.hasNewDone()
                } else if (a && (a.status === 'RUNNING' || a.status === 'WAITING')) {
                    this.hasNewRunning()
                }
            },
            taskStatusChanged(a) {
                if (a && (a.status === 'DONE' || a.status === 'FAILED' || a.status === 'CANCELLED' || a.status === 'ABORTED')) {
                    this.overrideDone.push(a.id)
                    this.hasNewDone()
                } else if (a && (a.status === 'RUNNING' || a.status === 'WAITING')) {
                    this.hasNewRunning()
                }
            },
            load (_e, _f) {
                if (this.loading) {
                    return
                }

                this.loading = true

                list().then((res) => {
                    const tasks = res.map((task) => {
                        if (this.overrideDone.indexOf(task.id) > -1) {
                            task.status = 'DONE'
                        }

                        return task
                    }).filter((task) => {
                        return !this.tasks.some(_ => _.id === task.id)
                    })

                    if (tasks.some(_ => _.status === 'RUNNING' || _.status === 'WAITING')) {
                        this.hasNewRunning()
                    }

                    this.tasks = tasks.concat(this.tasks)

                    this.loading = false
                })
            },
            buttonClicked (evt, button) {
                if (!button) {
                    evt.preventDefault()
                    return false;
                }

                if (button.isExplicitLink || evt.ctrlKey || evt.metaKey) {
                    return true
                }

                evt.preventDefault()

                switch (button.type) {
                    case 'PROPERTY':
                        this.$refs.propertyInfo.showById(button.propertyId)
                        break;
                    case 'CUSTOMER':
                        this.ui.currentCustomerId = button.customerId
                        setTimeout(() => {
                            this.$els.viewCustomerButton.click()
                        }, 100)
                        break;
                }

                return false
            },
            move (anchor) {
                this.$anchor = anchor

                const rect = anchor.getBoundingClientRect()
                const viewportWidth = document.documentElement.clientWidth
                const panelWidth = Math.min(360, viewportWidth - 16)

                this.top = rect.bottom + window.scrollY + 8
                this.right = Math.max(8, Math.min(viewportWidth - rect.right, viewportWidth - panelWidth - 8))
            },
            toggle (anchor) {
                if (this.visible) {
                    this.hide()
                } else {
                    this.show(anchor)
                }
            },
            show (anchor) {
                this.lastOpen = moment().utc().format("YYYY-MM-DD HH:mm:ss")
                localStorage.setItem("queue:last-open", this.lastOpen)

                this.hasNewChanged && this.hasNewChanged(false)

                this.move(anchor)
                this.visible = true

                this.load()

                this.createEvent()
            },
            hide () {
                this.visible = false

                this.destroyEvent()
            },
            createEvent () {
                this.destroyEvent()
                document.documentElement.addEventListener('click', this.bodyClicked)
                window.addEventListener('scroll', this.bodyScrolled, true)
                window.addEventListener('resize', this.bodyScrolled)
            },
            destroyEvent () {
                document.documentElement.removeEventListener('click', this.bodyClicked)
                window.removeEventListener('scroll', this.bodyScrolled, true)
                window.removeEventListener('resize', this.bodyScrolled)
            },
            bodyScrolled (e) {
                if (!utils.isElementInViewport(this.$anchor)) {
                    this.hide()
                } else {
                    this.move(this.$anchor)
                }
            },
            bodyClicked (e) {
                const parent = this.$parent

                if (parent.constructor.name === 'NavbarTasks') {
                    if (!parent.$el.contains(e.target) && !this.$els.dropdown.contains(e.target)) {
                        this.hide()
                    }
                } else {
                    if (!this.$els.dropdown.contains(e.target)) {
                        this.hide()
                    }
                }
            },
            getStyle () {
                const style = {}

                style.top = this.top + 'px'
                style.right = this.right + 'px'

                // if (this.position === 'right') {
                //     style.right = 0
                //     style.left = 'auto'
                // } else {
                //     style.top = this.top
                //     style.left = this.left
                // }

                style.width = '360px'
                style.maxWidth = 'calc(100vw - 16px)'
                style.display = 'block'

                return style
            },
        },
        computed: {
            hasTasks () {
                return this.tasks.length > 0
            }
        },
        watch: {
            visible (newVal) {
                this.visibilityChanged(newVal)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Dropdown.vue?73d76e61